import React, { useState } from "react";
import {
  FaArrowLeft,
  FaCamera,
  FaUserAlt,
  FaEllipsisH,
  FaSignOutAlt,
} from "react-icons/fa";
import "./profilePage.css"; // Import the CSS file
import UserAvater from "../../assets/images/user-avater.png";
import ResetPassword from "./PasswordReset";
import EdsgLogo from "../../assets/images/ConnectHealthPro.png";
import { logout } from "../../utility/auth";

const ProfilePage = () => {
  const [userPix, setUserPix] = useState("");
  const [showResetModal, setShowResetModal] = useState(false);
  // Get userInfo from localStorage/sessionStorage or context
  const userInfo = JSON.parse(localStorage.getItem('USER_INFO'))

  const handlePasswordResetClick = () => setShowResetModal(true);
  const handleCloseModal = () => setShowResetModal(false);

  return (
    <div className="profile-container">
      {/* <div className="profile-header">
        <FaArrowLeft className="back-icon" />
      </div> */}
      <div className="header-logo">
        <div className="logo-text">
          <img
            style={{ height: "80px", width: "100%" }}
            src={EdsgLogo}
            alt="ConnectHealthPro Logo"
          />
        </div>
      </div>

      <div className="profile-card">
        <div className="profile-image-container">
          <img
            style={{ width: "80px", height: "100%", borderRadius: "50%" }}
            // onError={handleImgError}
            src={userPix || UserAvater}
            alt="user avater"
          />
          {/* <button className="upload-photo-button">
            <FaCamera className="camera-icon" /> UPLOAD PHOTO
          </button> */}
        </div>
          <h3>{userInfo?.firstName} {userInfo?.lastName}</h3>
        {/* <h2 className="profile-name">{userInfo.name || "James Nick"}</h2> */}
        <div className="status-indicator"></div>
      </div>

      <div className="profile-menu">
        {/* <div className="menu-item">
          <FaUserAlt className="menu-icon" />
          <div className="menu-text">
            <h3>My Profile</h3>
            <p>View and edit your profile</p>
          </div>
        </div> */}
        <div
          className="menu-item"
          onClick={handlePasswordResetClick}
          style={{ cursor: "pointer" }}
        >
          <FaEllipsisH className="menu-icon" />
          <div className="menu-text">
            <h3>Password Reset</h3>
            <p>Change your password</p>
          </div>
        </div>
        <div className="menu-item logout" onClick={logout}>
          <FaSignOutAlt className="menu-icon logout-icon" />
          <div className="menu-text">
            <h3>Logout</h3>
            <p>Sign out of your account</p>
          </div>
        </div>
      </div>

      {showResetModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="close-modal" onClick={handleCloseModal}>
              &times;
            </button>
            <ResetPassword />
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfilePage;
